import React, { FC } from 'react';
import { TOOLTIP_SHOW_DELAY } from '../../../../constants/Delay';
import { Text } from '../../../common';
import { IOuter } from './ItemName.types';

export const ItemName: FC<IOuter> = ({ onClick, children }) => (
  <Text ellipsis secondary size="tiny" tagName="div" weight="thin" onClick={onClick} showDelay={TOOLTIP_SHOW_DELAY}>
    {children}
  </Text>
);
